import apiClient from './apiClient';

export const getLotteryGames = () => apiClient.get('/lottery_game');

export const createLotteryGame = (data) => apiClient.post('/lottery_game', data);

export const updateLotteryGame = (id, data) => apiClient.put(`/lottery_game/${id}`, data);

export const deleteLotteryGame = (id) => apiClient.delete(`/lottery_game/${id}`);
